<!-- weight -->
<p *ngIf="showLabel" class="body1">Weight</p>

<div class="measure">
    <my-health-admin-answer
        class="value"
        [data]="data"
        [answer]="weight.value"
        [editMode]="editMode"
        (childChange)="handleChildChange()"
    ></my-health-admin-answer>
    <span class="divider" [innerHTML]="division"></span>
    <my-health-admin-answer
        class="unit"
        [data]="data"
        [answer]="weight.unit"
        (childChange)="handleChildChange()"
        [editMode]="editMode"
    ></my-health-admin-answer>
</div>

<!-- height -->
<p *ngIf="showLabel" class="body1">Height</p>

<div class="measure">
    <my-health-admin-answer
        *ngIf="data['heightUnit'] !== 'feetIn'; else feetInTmp"
        class="value"
        [data]="data"
        [answer]="heightAnswerValue"
        [editMode]="editMode"
    ></my-health-admin-answer>
    <span class="divider" [innerHTML]="division"></span>
    <my-health-admin-answer
        class="unit"
        [data]="data"
        [answer]="height.unit"
        [editMode]="editMode"
    ></my-health-admin-answer>
</div>

<ng-template #feetInTmp>
    <div style="width: 45%">
        <my-health-admin-answer
            [data]="data"
            [answer]="{ type: 'feetIn', size: 'large' }"
            [editMode]="editMode"
        ></my-health-admin-answer>
    </div>
</ng-template>
